<nav class="navbar navbar-expand-lg d-none d-lg-flex px-3" role="navigation" aria-label="Main navigation">
  <a
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
  >
    <span class="accessibility-only" id="homeLink">Go To Home Page</span>
    <img alt="" class="ms-1 h-100" aria-labelledby="homeLink" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    [attr.aria-expanded]="!isCollapsed"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse flex-grow-1" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <!-- <ul class="navbar-nav" #greedyNav role="menubar">
        <li class="nav-item active" role="none">
          <a
            class="nav-link mx-1 text-white"
            [routerLink]="['/rewards/marketplace']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
            >{{ 'nav.rewards' | translate }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link mx-1 text-white"
            [routerLink]="['/challenges']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.challenges.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
            >{{ 'nav.challenges' | translate }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link mx-1 text-white"
            [routerLink]="['/earn']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.rookies.screenreader' | translate : { fgbdefault: 'Move to Thunder Rookies Club page' } }}"
            >{{ 'nav.rookies' | translate : { fgbdefault: 'Thunder Rookies Club' } }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link mx-1 text-white"
            [routerLink]="['/rewards/wallet']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.wallet.screenreader' | translate : { fgbdefault: 'Move to Wallet page' } }}"
            >{{ 'nav.wallet' | translate }}</a
          >
        </li>
      </ul> -->
    </div>

    <!-- Right Side Content -->
    <div
      class="d-flex align-items-center flex-nowrap my-2 my-lg-0 ms-auto"
      role="toolbar"
      aria-label="Account and balance toolbar"
    >
      <!-- Points Balance -->
      <ng-container *inPopulation="['STH']">
        <div class="balance font-size-14" *ngIf="loyaltyPointsCard$" aria-live="polite">
          <div class="bg-glass glass-bg d-flex align-items-center">
            <div class="d-flex align-items-center text-white">
              <span class="icon material-symbols-outlined pe-1 font-size-20" aria-hidden="true">loyalty</span>

              <span
                class="fw-bold"
                attr.aria-label="{{ 'nav.points.screenreader' | translate }} {{
                  loyaltyPointsCard$ | async | FortressCurrencyPipe : 'PTS'
                }}"
                >{{ loyaltyPointsCard$ | async | FortressCurrencyPipe : 'PTS' }}</span
              >
            </div>
          </div>
        </div>
      </ng-container>

      <!--  Balance -->
      <div class="balance font-size-14 ps-0" *inPopulation="['Employee']" aria-live="polite">
        <div class="bg-glass glass-bg d-flex align-items-center">
          <div class="d-flex align-items-center text-white">
            <span class="icon material-symbols-outlined me-2 font-size-20" aria-hidden="true">money_bag</span>
            <span
              class="fw-bold"
              attr.aria-label="{{ 'nav.ecash.screenreader' | translate }} {{ virtualEcash$ | async | FortressCurrencyPipe }}"
              >{{ virtualEcash$ | async | FortressCurrencyPipe }}</span
            >
          </div>
        </div>
      </div>

      <!-- <fgb-notification-button></fgb-notification-button> -->

      <!-- Menu Toggle Button -->
      <button
        class="nav-link btn d-flex align-items-center mx-2 px-0 justify-content-end"
        (click)="toggleSideNav()"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="rightNavMenu"
        attr.aria-label="{{
          'nav.account.menu.screenreader'
            | translate : { fgbdefault: isNavOpen ? 'Close navigation menu' : 'Open navigation menu' }
        }}"
        focusTab
      >
        <i class="material-symbols-outlined text-white menu-icon" aria-hidden="true">dehaze</i>
      </button>
    </div>
  </div>
</nav>

<!-- Loading  -->
<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4" aria-busy="true" aria-label="Loading member details">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>

<!-- Side Nav  -->
<div
  class="right-nav-menu-overlay"
  *ngIf="isNavOpen"
  [@rightMenuOverlayAnimation]
  (click)="isNavOpen = false"
  aria-hidden="true"
></div>

<!-- Side Nav Menu -->
<nav
  id="rightNavMenu"
  class="right-nav-menu bg-card-fill"
  [@rightNavAnimation]="isNavOpen ? 'open' : 'close'"
  [ngClass]="{ open: isNavOpen }"
  [attr.aria-hidden]="!isNavOpen"
  aria-label="Side navigation"
  role="navigation"
>
  <div class="d-flex flex-column">
    <!-- Close Button -->
    <button
      type="button"
      class="btn-close position-absolute"
      (click)="isNavOpen = false"
      aria-label="Close navigation menu"
    ></button>

    <!-- Club Logo -->
    <div class="d-flex align-items-center justify-content-start brand-logo">
      <img class="brand" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" alt="Fortress logo" />
    </div>

    <!-- Member Info -->
    <div class="modal-content d-flex gap-2 rounded-0 text-black" aria-live="polite">
      <div class="modal-header w-100 d-flex align-items-center justify-content-between mt-3">
        <div class="member-card text-white rounded">
          <div>
            <div
              class="card-name fw-bold text-uppercase font-size-18 font-page-heading"
              *ngIf="memberDetails$ | async as memberDetails"
            >
              {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
            </div>
            <div class="account-num-header font-size-12 d-flex flex-row align-items-center" *ngIf="card$ | async as memberCard">
              <span class="">{{ 'member.id' | translate }} {{ memberCard.ExternalRefNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Nav Links -->
    <ul class="right-nav-menu-list mt-3" role="menubar" aria-label="Side navigation links">
      <!-- <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="icon material-symbols-outlined" aria-hidden="true">account_circle</span>{{ 'nav.account' | translate }}
          </div>
        </a>
      </li>

      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/earn']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="icon material-symbols-outlined" aria-hidden="true">money</span>{{ 'nav.earn' | translate }}
          </div>
        </a>
      </li>

      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="icon material-symbols-outlined" aria-hidden="true">animated_images</span>{{ 'nav.gallery' | translate }}
          </div>
        </a>
      </li> -->
      <!-- Earn Points -->
      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/earn']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="icon material-symbols-outlined" aria-hidden="true">money</span>{{ 'nav.earn' | translate }}
          </div>
        </a>
      </li>

      <!-- Help Group -->
      <li role="none">
        <button
          class="right-nav-menu-item right-nav-menu-group text-black w-100 text-start border-0 bg-transparent"
          (click)="isHelpOpen = !isHelpOpen"
          [attr.aria-expanded]="isHelpOpen"
          aria-controls="helpSubmenu"
          attr.aria-label="{{ isHelpOpen ? 'Collapse help menu' : 'Expand help menu' }}"
          role="menuitem"
          aria-haspopup="true"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="nav-text">
              <span class="icon material-symbols-outlined" aria-hidden="true">info</span>{{ 'nav.help' | translate }}
            </div>
            <span class="material-symbols-outlined help-chevron" [class.open]="!isHelpOpen" aria-hidden="true"
              >keyboard_arrow_right</span
            >
          </div>
        </button>

        <ul id="helpSubmenu" class="help-submenu list-unstyled" *ngIf="!isHelpOpen" role="menu" aria-label="Help sub-menu">
          <li role="none" class="pb-2">
            <a
              class="right-nav-menu-subitem text-black"
              [routerLink]="['/terms']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              role="menuitem"
              (click)="isNavOpen = false"
              attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
            >
              <div class="nav-text">{{ 'nav.terms' | translate }}</div>
            </a>
          </li>
          <li role="none" class="pb-2">
            <a
              class="right-nav-menu-subitem text-black"
              [routerLink]="['/faq']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              role="menuitem"
              (click)="isNavOpen = false"
              attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to FAQ page' } }}"
            >
              <div class="nav-text">{{ 'nav.faq' | translate }}</div>
            </a>
          </li>
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.contact.us'">
            <li role="none" class="pb-2">
              <a
                class="right-nav-menu-subitem text-black"
                [routerLink]="['/contact']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
                role="menuitem"
                (click)="isNavOpen = false"
                attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
              >
                <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
    </ul>

    <!-- Logout -->
    <button
      class="log-out bg-transparent"
      (click)="logout()"
      attr.aria-label="{{ 'nav.log.out.screenreader' | translate : { fgbdefault: 'Log out of your account' } }}"
    >
      <i class="material-symbols-outlined" aria-hidden="true">logout</i>
      <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
    </button>
  </div>
</nav>
